import React from 'react';
import { Col, Row } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { TextField } from '../../../shared/TextField';
import { injectIntl } from 'react-intl';
import { SelectField } from "../../../shared/SelectField";
import { AddTracking } from "./actions/AddTracking";
import { RemoveTracking } from "./actions/RemoveTracking";
import { TRACKING_OPTIONS_PLATFORMS } from "../../../../config/constants/Campaign/campaign_constants";
import { FieldMessages } from "../../../layout/Messages/FieldMessages";
import {NOTIFICATION_CREATE_CAMPAIGN, NOTIFICATION_UPDATE_CAMPAIGN} from "../../../../config/notifications";


function TrackingRowComponent(props) {
  const { formikProps, tracking, setTracking, index, initialValues, setInitialValues } = props;

  const deep_value = (obj, path) => {
    return path
      .replace(/\[|\]\.?/g, '.')
      .split('.')
      .filter(s => s)
      .reduce((acc, val) => acc && acc[val], obj);
  }

  const getErrorClassTracking = (formikProps, fieldName) => {
    if (formikProps && formikProps.touched && deep_value(formikProps && formikProps.touched, fieldName) !== undefined) {
      if (formikProps.errors && deep_value(formikProps && formikProps.errors, fieldName) !== undefined) {
        return 'custom-is-invalid';
      }
    }

    return '';
  }

  return (<Row className="create-campaign-tracking-row">
      <Col xs={ 12 } sm={ 6 } >
        <label className='form-control-label d-block'>
          <FormattedMessage id="fields.campaignManagement.tracking_name"/>
        </label>
        <SelectField
          name="tracking_name"
          className={ `mb-4 ${ getErrorClassTracking(formikProps, `campaign_trackings[${index - 1}][tracking_label]`) }` }
          classNamePrefix="ml-0"
          defaultValue={ TRACKING_OPTIONS_PLATFORMS[0] }
          options={ TRACKING_OPTIONS_PLATFORMS }
          onChange={
            option => formikProps.setFieldValue(`campaign_trackings[${index - 1}][tracking_label]`, option.value)
          }
          formikProps={ formikProps }
        />
        <FieldMessages
          color="danger"
          formikProps={ props.formikProps }
          class="small-field-error mt--4"
          showDismiss={ false }
          name={ `campaign_trackings.${index - 1}.tracking_label` }
          notificationId={ [NOTIFICATION_UPDATE_CAMPAIGN, NOTIFICATION_CREATE_CAMPAIGN] }
        >
          { deep_value(formikProps && formikProps.errors, `campaign_trackings.${index - 1}.tracking_label`) }
        </FieldMessages>
      </Col>
      <Col xs={ 12 } sm={ 6 } >
        <Row>
          <Col
            xs={ TRACKING_OPTIONS_PLATFORMS.length === 1 ? 12 : 10 }
            sm={ TRACKING_OPTIONS_PLATFORMS.length === 1 ? 12 : 10 }
          >
            <label className='form-control-label d-block'>
              <FormattedMessage id="fields.campaignManagement.tracking_id" />
            </label>
            <TextField
              name="campaignManagement.tracking_id"
              handleBlur={ formikProps.handleBlur }
              fontAwesome="faBuilding"
              onChange={
                event => {
                  formikProps.setFieldValue(`campaign_trackings[${index - 1}][tracking_id]`, event.target.value || '');
                }
              }
              value={ (formikProps.values.campaign_trackings && formikProps.values.campaign_trackings[index - 1] && formikProps.values.campaign_trackings[index - 1].tracking_id) || '' }
              errorClass={ getErrorClassTracking(formikProps, `campaign_trackings.${index - 1}.tracking_id`) }
            />
            <FieldMessages
              color="danger"
              formikProps={ props.formikProps }
              class="small-field-error mt--4"
              showDismiss={ false }
              name={ `campaign_trackings.${index - 1}.tracking_id` }
              notificationId={ [NOTIFICATION_UPDATE_CAMPAIGN, NOTIFICATION_CREATE_CAMPAIGN] }
            >
              { deep_value(formikProps.errors, `campaign_trackings[${index - 1}][tracking_id]`) }
            </FieldMessages>
          </Col>
          <Col xs={ 2 } sm={ 2 }>
            <Row className="create-campaign-tracking-actions justify-content-end mr-1 mt-1">
              <AddTracking
                tracking={ tracking }
                setTracking={ setTracking }
                initialValues={ initialValues }
                setInitialValues={ setInitialValues }
              />
              <RemoveTracking
                tracking={ tracking }
                setTracking={ setTracking }
                initialValues={ initialValues }
                setInitialValues={ setInitialValues }
                index={ index }
              />
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

const TrackingRow = injectIntl(TrackingRowComponent);

export { TrackingRow, TrackingRowComponent }
